import React from 'react';
import { useTranslation } from '../../i18n/useTranslation.js';

interface SaveBarProps {
  dirty: boolean;
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

function SaveBar({ dirty, saving, onCancel, onSave }: SaveBarProps) {
  const { t } = useTranslation();
  return (
    <div className="save-bar">
      <button className="btn-cancel" onClick={onCancel} disabled={!dirty || saving}>
        {t('saveBar.cancel')}
      </button>
      <button className="btn-save" onClick={onSave} disabled={!dirty || saving}>
        {saving ? t('saveBar.saving') : t('saveBar.saveChanges')}
      </button>
    </div>
  );
}

export default SaveBar;
